/* eslint-disable no-console */
import { api } from '@/services/api';
import { POLES_SET, POLES_LOADING, POLES_LOADED, POLE_CREATED } from '../actionTypes';
import { showAlert } from './theme';

export const setPoles = (poles) => ({
  type: POLES_SET,
  payload: poles,
});

export const loadingPoles = () => ({
  type: POLES_LOADING,
});

export const loadedPoles = () => ({
  type: POLES_LOADED,
});

export const createdPole = (created) => ({
  type: POLE_CREATED,
  payload: created,
});

export const fetchPoles = () => {
  return (dispatch) => {
    dispatch(loadingPoles());

    api
      .get('/Polo/GetAll')
      .then((data) => {
        dispatch(setPoles(data.data));
        dispatch(loadedPoles());
      })
      .catch((error) => {
        console.log('error comming', error);
      });
  };
};

export const createPole = (data) => {
  return (dispatch) => {
    dispatch(loadingPoles());

    api
      .post(`/Polo`, data)
      .then(() => {
        dispatch(loadedPoles());
        dispatch(createdPole(true));
      })
      .catch((error) => {
        dispatch(
          showAlert({
            type: 'danger',
            message: error.response.data.Message,
            time: 3000,
          })
        );
        dispatch(loadedPoles());
        dispatch(createdPole(false));
      });
  };
};

// ==========================================
// NOVAS ACTIONS: VISUALIZAR POLO (BFF)
// ==========================================

export const requestPoleChangeTicket = (payload) => {
  // Retornamos async (Promise) para que a View possa usar o "await dispatch(...)"
  return async (dispatch) => {
    try {
      // Como a API C# agora segue o padrão, o nosso interceptor (api.js) 
      // injeta o "Authorization: Bearer token" sozinho.
      await api.post('/Api/Suporte/CriarTicket', payload);

      dispatch(
        showAlert({
          type: 'success',
          message: 'Ticket de alteração solicitado com sucesso na plataforma Octadesk!',
          time: 4000,
        })
      );

      // Retorna true para a View saber que deu certo e limpar o formulário
      return true; 
    } catch (error) {
      console.log('error comming', error);
      
      // Tenta pegar a mensagem de erro que vem da API, ou usa uma genérica
      const errorMessage = error.response?.data?.Message || 'Falha ao solicitar o ticket. Tente novamente mais tarde.';
      
      dispatch(
        showAlert({
          type: 'danger',
          message: errorMessage,
          time: 4000,
        })
      );
      
      // Retorna false para a View manter a caixa de texto aberta
      return false; 
    }
  };
};